export default __webpack_public_path__ + "static/media/SG-LightBlue-0005.127c2145.png";